
import { BillingCycleEntity, EMPTY_BILLING_CYCLE_ENTITY } from "domain/entity/BillingCycle/BillingCycleEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface TariffCodeDropdownOptions {
    billingCycleTypeDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
    editingEntity: BillingCycleEntity,
}

export interface BillingCycleMaintenanceModel {
    isLoading: boolean,
    tableData: BillingCycleEntity[],
    currentSelectedRow: BillingCycleEntity,
    selectedRows: BillingCycleEntity[],
    dynamicOptions: TariffCodeDropdownOptions,
    masterState: MasterChangeState,
    isBackMaster: boolean,
    isShowEditPanel: boolean,
}

export const EMPTY_MASTER_BILLING_CYCLEANY_MODEL: BillingCycleMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_BILLING_CYCLE_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        billingCycleTypeDropdownOptions: []
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_BILLING_CYCLE_ENTITY,
    },
    isBackMaster: false,
    isShowEditPanel: false,
}